<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <select
    :value="item"
    :class="['vacancy-pill', `vacancy-pill--${tone}`]"
    @click.stop
    @change="pick($event.target.value)"
  >
    <option v-for="p in options" :key="p.id" :value="p.id">
      {{ p.label }}
    </option>
  </select>
</template>

<script>
// A vacancy list cell (priority, status): a coloured select, changed in place.
export default {
  name: 'VacancyPillCell',
  props: {
    item: {
      type: [Number, String],
      required: true,
    },
    // [{id, label, tone}]
    options: {
      type: Array,
      required: true,
    },
    onPick: {
      type: Function,
      required: true,
    },
  },
  computed: {
    tone() {
      return this.options.find((o) => o.id === this.item)?.tone || 'grey';
    },
  },
  methods: {
    pick(value) {
      // a select's value is a string; give back the option's own id
      const option = this.options.find((o) => String(o.id) === value);
      if (option) this.onPick(option.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.vacancy-pill {
  border: 0;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  &--red {
    background: #fde4e1;
    color: #c62828;
  }
  &--blue {
    background: #eaf2fb;
    color: #1f5fa8;
  }
  &--green {
    background: #e3f3e6;
    color: #2e7d32;
  }
  &--amber {
    background: #fff3d6;
    color: #a05a00;
  }
  &--grey {
    background: #eef1f5;
    color: #64728c;
  }
}
</style>
